// Inbound WhatsApp text and button replies, turned into intents.
import { TOKEN_REGEX } from './ids';

export type InboundIntent =
  | { kind: 'register'; token: string }
  | { kind: 'stop' }
  | { kind: 'feedback'; rating: 1 | 2 | 3 }
  | { kind: 'text'; text: string };

const STOP_WORDS = /^\s*(stop|arr[eê]t(er)?|stopper|توقف|إيقاف|ايقاف|وقف)\s*[.!]?\s*$/iu;

const TOKEN_RUNS = new RegExp(TOKEN_REGEX.source, 'g');

/**
 * Token-shaped runs in a message, best first. A receipt number can have six digits (ticket mode) and then looks
 * exactly like a token, and the prefill puts the number before the token. So: runs with a letter first, in text
 * order (a receipt number never has one), then digit-only runs from the last one backwards. Duplicates are dropped.
 */
export function tokenCandidates(text: string): string[] {
  const runs = Array.from(text.toUpperCase().matchAll(TOKEN_RUNS), (m) => m[1]);
  const lettered = runs.filter((r) => /[A-Z]/.test(r));
  const digitsOnly = runs.filter((r) => !/[A-Z]/.test(r)).reverse();
  return Array.from(new Set([...lettered, ...digitsOnly]));
}

export function parseInboundText(text: string): InboundIntent {
  if (STOP_WORDS.test(text)) return { kind: 'stop' };
  const [token] = tokenCandidates(text);
  if (token) return { kind: 'register', token };
  return { kind: 'text', text: text.trim() };
}

/** Quick-reply button ids are `fb_3` (best) to `fb_1` (worst). */
export function parseButtonId(id: string): InboundIntent | null {
  const m = /^fb_([123])$/.exec(id);
  if (!m) return null;
  return { kind: 'feedback', rating: Number(m[1]) as 1 | 2 | 3 };
}

export function feedbackButtonId(rating: 1 | 2 | 3): string {
  return `fb_${rating}`;
}
